if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        this.fetchRecommendations(this.dataset.url);
      }

      fetchRecommendations(url, isFallback = false) {
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) {
              this.handleNoRecommendations(isFallback);
              return;
            }

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (!recommendations) {
              this.handleNoRecommendations(isFallback);
              return;
            }

            if (recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              this.handleNoRecommendations(isFallback);
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleNoRecommendations(isFallback);
          });
      }

      handleNoRecommendations(isFallback) {
        // If this was the primary request and we have a fallback URL, try that
        if (!isFallback && this.dataset.fallbackUrl) {
          this.fetchRecommendations(this.dataset.fallbackUrl, true);
          return;
        }

        // No recommendations found even after fallback
        if (this.classList.contains('complementary-products')) {
          this.closest('.product__block')?.remove();
        } else {
          this.closest('.shopify-section')?.remove();
        }
        this.dispatchEvent(new CustomEvent('recommendations:empty'));
      }
    }
  );
}
